
//系统目录 / 药品剂型 接口相关的函数
import request from "../../untils/request.js"

/**
 *
 *  post
 *
 */

//门诊零售开药新增
export const addDrugtemplate = (data) => {
    return request.post("/outpatient/drugtemplate", data )
}

//门诊零售开药修改
export const editDrugtemplate = (data) => {
    return request.put("/outpatient/drugtemplate", data )
}

//门诊零售开药分页
export const getDrugTemplatePage = (params) => {
    return request.get("/outpatient/drugtemplate/page", { params } )
}

//门诊零售开药分页
export const getDrugTemplateList = (params) => {
    return request.get("/outpatient/drugtemplate/list", { params } )
}

//生成健康Id
export const generateHealthSystemId = (data) => {
    return request.get("/outpatient/seedoctor/autoGenerate", data)
}

//生成健康Id
export const addOrdersRetail = (data) => {
    return request.post("/outpatient/api/v2/outpatient/orders/retail", data)
}

export const uploadRetail = (data) => {
    return request.post("/outpatient/msfx/uploadRetail", data)
}

export const getDocumentNo = (params) => {
    return request.get("/outpatient/index/documentNo", { params })
}